import '../vendor/jquery.lazyload'

/**
*  Utility JavaScript functions
*/
var mobile_util = {};

/**
 * portraitWidth() returns width of device in portrait mode
 */
mobile_util.portraitWidth = function () {
  return Math.min(window.innerHeight, window.innerWidth);
};

/**
 * portraitHeight() returns height of device in portrait mode
 */
mobile_util.portraitHeight = function () {
  return Math.max(window.innerHeight, window.innerWidth);
};

/**
 * portraitMode() returns boolean indicating if user is in portrait mode
 */
mobile_util.portraitMode = function () {
  return window.innerWidth < window.innerHeight;
};

/**
 * landscapeMode() returns boolean indicating if user is in landscape mode
 */
mobile_util.landscapeMode = function () {
  return !this.portraitMode();
};

/**
 * deviceAspectRatio() returns ratio of portrait width / height
 */
mobile_util.deviceAspectRatio = function () {
  return this.portraitWidth() / this.portraitHeight();
};

/**
 * isIOS() returns a boolean indicating if the user is on a mobile iOS device
 */
mobile_util.isIOS = function () {
  return (/(iPad|iPhone|iPod)/i).test(navigator.userAgent);
};

/**
 * isIOSWebView() returns a boolean indicating if the user is viewing the page
 * via a UIWebView on iOS (i.e., within another app)
 */
mobile_util.isIOSWebView = function () {
  return this.isIOS() && !(/Safari/i).test(navigator.userAgent);
};

/**
* getIOSVersion() returns the top-level version of iOS as extracted from the
* UserAgent string (e.g., 10 for 10.0.1), or a falsey value if the UserAgent is
* not iOS
*/
mobile_util.getIOSVersion = function () {
  var regexp = new RegExp(/OS (\d+)/);
  var match = regexp.exec(navigator.userAgent);
  return this.isIOS() && match && match.length >= 2 && parseInt(match[1], 10);
};

/**
 * isSupportedIOS() returns a boolean indicating if the user is on an iOS8 or above device
 */
mobile_util.isSupportedIOS = function () {
  return this.getIOSVersion() >= 8;
};

/**
 * isIPad() returns a boolean indicating if the user is on an iPad
 */
mobile_util.isIPad = function() {
  return this.isIOS() && this.deviceAspectRatio() == 0.75;
};

/**
 * isIOSTwitterWebView() returns a boolean indicating if the user
 * is using the webview in the iOS twitter app
 */
mobile_util.isSupportedIOSTwitterWebView = function (){
  return this._checkAppWebViewUsingReferer('twitter');
};

/**
 * isSupportedIOSLinkedinWebView() returns a boolean indicating if the user
 * is using the webview in the iOS Linkedin app
 */
mobile_util.isSupportedIOSLinkedinWebView = function (){
  return this._checkAppWebViewUsingReferer('linkedin');
};

/**
 * _checkAppWebViewUsingReferer() returns a boolean indicating if the user
 * is using an app webview using a predetermined set of options
 * Note: Also checks if the device is IOS8 and sets a cookie to track
 * across the session
 *
 * @param <String> appName - the app name we are checking for
 */
mobile_util._checkAppWebViewUsingReferer = function (appName){
  var APP_OPTIONS = {
    "linkedin" : {
      "regex" : /^(https?:\/\/)?lnkd\.in/i,
      "cookie" : "linkedinReferred"
    },
    "twitter" : {
      "regex" : /^(https?:\/\/)?t\.co\//i,
      "cookie" : "twitterReferred"
    }
  };

  var app_options = APP_OPTIONS[appName];

  if (app_options === undefined){
    return false;
  }

  if (this.isIOSWebView && this.isSupportedIOS()) {
    if (app_options.regex.test(document.referrer)) {
      // set cookie to indicate that this is an app webview
      // for further navigation
      this.setCookie(app_options.cookie, 'true');
      return true;
    } else if (this.getCookie(app_options.cookie) == 'true') {
      return true;
    }
  }

  return false;
};

/**
 * isSupportedIOSFacebookWebView() returns a boolean indicating if the user
 * is using the webview in the iOS Facebook app
 */
mobile_util.isSupportedIOSFacebookWebView = function (){
  return this.isSupportedIOS() && (/FBIOS/).test(navigator.userAgent);
};

/**
 * isAndroid() returns a boolean indicating if the user is on an Android device
 */
mobile_util.isAndroid = function () {
  return (/Android/).test(navigator.userAgent);
};

/**
 * isAndroidWebView() returns a boolean indicating if the user is viewing the
 * page via a WebView on an Android device (i.e., within another app)
 */
mobile_util.isAndroidWebView = function () {
  return this.isAndroid() && (/Version\/(\d+\.)+(\d+)/).test(navigator.userAgent);
};

/**
 * isAndroidTablet() returns a boolean indicating if the user is on an Android
 *   tablet
 */
mobile_util.isAndroidTablet = function () {
  return !(/Mobile/).test(navigator.userAgent) && this.isAndroid() &&
    this.portraitWidth() >= 600;
};

/**
 * isAndroidPhone() returns a boolean indicating if the user is on an Android
 *   phone
 */
mobile_util.isAndroidPhone = function () {
  return this.isAndroid() && !this.isAndroidTablet();
};

/**
 * isMobile() returns a boolean indicating if the user is on a mobile device
 */

export let isMobile = function () {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent);
};

mobile_util.isMobile = isMobile;

/**
 * hasCookie() returns a boolean indicating there is a cookie which corresponds
 * to the given cookie_string
 *
 * @param <String> cookieString - the cookie who's presence we are checking for
 */
mobile_util.hasCookie = function (cookieString) {
  return document.cookie.indexOf(cookieString) >= 0;
};

/**
 * onEvenParityPreso() returns true if slideshare_mobile_object.slideshow.slideshowId
 * is defined and has even parity (i.e., <ssid> % 2 === 0)
 */
mobile_util.onEvenParityPreso = function () {
  return typeof(window.slideshare_mobile_object) !== 'undefined' &&
    window.slideshare_mobile_object.slideshow &&
    window.slideshare_mobile_object.slideshow.slideshowId % 2 === 0;
};

/**
 * onVideo() returns true if slideshare_mobile_object.slideshow.slideshowType
 * is defined and has is equal to 'video'
 */
mobile_util.onVideo = function () {
  return typeof(window.slideshare_mobile_object) !== 'undefined' &&
    window.slideshare_mobile_object.slideshow &&
    window.slideshare_mobile_object.slideshow.slideshowType === 'video';
};

/**
 * setCookie() sets the value of a cookie
 *
 * @param <String> name - name of the cookie who's value we're setting
 * @param <String> value - the value we are setting the cookie to
 * @param <Number> lifespan - number of days we want the cookie to persist for
 */
mobile_util.setCookie = function (name, value, lifespan) {
  value = value || 0;
  lifespan = lifespan || 7;

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + lifespan);

  document.cookie = name + "=" + value + "; expires=" + expirationDate +  "; path=/";
};

/**
 * getCookie() gets the value of a cookie
 *
 * @param <String> name - name of the cookie who's value we're getting
 */
mobile_util.getCookie = function (name) {
  var pattern = new RegExp(name + "=.[^;]*");
  var matched = document.cookie.match(pattern);

  if (matched) {
    return matched[0].split('=')[1];
  }

  return false;
};

/**
 * lazyloadImages() will render lazyload images corresponding to given selector
 *
 * @param <String> selector - the css selector corresponding to the images to load
 * @param <Number> threshold - the # of pixels above the image the screen can
 *   be before which we will load the images
 */
mobile_util.lazyloadImages = function (selector, threshold) {
  threshold = threshold || 0;

  var doLazyload = function () {
    $(selector).lazyload({
      threshold: threshold
    });
  };

  if (typeof window.slideshare_mobile_object != 'undefined' &&
    window.slideshare_mobile_object.windowLoaded) {
    doLazyload();
  } else {
    $(window).load(function () {
      doLazyload();
    });
  }
};

/**
 * lazyloadImagesOnTrigger() will render lazyload images corresponding to given
 * selector, when the given trigger is triggered
 *
 * @param <String> selector - the css selector corresponding to the images to load
 * @param <String> trigger - the event to trigger lazyloading
 */
mobile_util.lazyloadImagesOnTrigger = function (selector, trigger) {
  $(selector).lazyload({
    event: trigger
  });
};

/**
 * lazyloadImagesOnTrigger() will render lazyload images corresponding to given
 * selector, with this lazyloading being triggered immediately
 *
 * @param <String> selector - the css selector corresponding to the images to load
 */
mobile_util.lazyloadImagesNow = function (selector) {
  this.lazyloadImagesOnTrigger(selector, "lazyLoadImagesNow_trigger");
  $(selector).trigger("lazyLoadImagesNow_trigger");
};

/**
 * trackGAEvent() adds a trackEvent to Google Analytics queue
 *
 * @param <String> currentPage - the page the user is on
 * @param <String> pageElement - the element on the page we are tracking
 *   (e.g. 'android_phone_splash')
 * @param <String> userAction - the action to track (e.g. 'clicked')
 * @param <Boolean> isNonInteractive - true for interactive events
 */
mobile_util.trackGAEvent = function (currentPage, pageElement, userAction, isNonInteractive) {
  isNonInteractive = isNonInteractive || false;
  var _gaq = window._gaq || [];
  _gaq.push(['_trackEvent', currentPage, pageElement, userAction, undefined, isNonInteractive]);
};

/**
 * addSpinnerTo() adds a spinner to the element specified
 *
 * @param <String> container - the element to prepend the spinner to
 * @param <String> size - the size of the spinner ('S','M','L','XL')
 * @param <String> color - the color of the spinner in HEX
 */
mobile_util.addSpinnerTo = function (container, size, color) {
  if (typeof container === 'undefined') {
    return;
  }
  color = color || '#FFFFFF'; // default white spinner

  var spinnerSizes = {
    'S': 'fa-lg',
    'M': 'fa-2x',
    'L': 'fa-3x',
    'XL': 'fa-4x'
  };

  // default medium spinner
  const spinnerSize = spinnerSizes[size.toUpperCase()] || spinnerSizes.M;

  var $container = $(container);
  var $faSpinner = $('<i class="fa fa-spinner fa-spin"></i>');

  $faSpinner.prependTo($container).addClass(spinnerSize).css({
    'color': color,
    'position': 'absolute',
    'z-index': 1000,
    'top': '50%',
    'transform': 'translate(-50%, -50%)',
    'left': '50%'
  });
};

/**
 * removeSpinnersFrom() removes all spinners from specified element
 *
 * @param <String> container - the element to remove spinners from
 */
mobile_util.removeSpinnersFrom = function (container) {
  if (typeof container === 'undefined') {
    return;
  }

  $(container).find('.fa-spinner').remove();
};

/**
 * IOSAutoDeepLink() tries to automatically open the Slideshare app
 * with a hidden iframe
 *
 * @param <String> deepLink - the deepLink url
 */
mobile_util.IOSAutoDeepLink = function (deepLink) {
  // Regex to match ss.net and international subdomains as well
  // staging.slideshare.com. Not too strict.
  var SS_HOSTNAME_REGEX = /^(https?:\/\/)?.*\.slideshare\.(net|com)/i;

  // Do not deeplink if user is browing through the mobile web
  if (SS_HOSTNAME_REGEX.test(document.referrer)) {
    return;
  }

  // Do not auto deeplink if in Twitter/FB/LI Apps
  if (this.isSupportedIOSFacebookWebView() ||
    this.isSupportedIOSTwitterWebView() ||
    this.isSupportedIOSLinkedinWebView()){
    return;
  }
  // Attempt deeplink after a second to allow immediate assets to load
  // before app pushes browser to background
  setTimeout(function() {
    var deeplinkIframe = document.createElement('IFRAME');
    deeplinkIframe.setAttribute('style', 'display:none;');
    deeplinkIframe.setAttribute('src', deepLink);
    document.body.appendChild(deeplinkIframe);
  }, 1000);
};

export default mobile_util;
